export const contactSupportMessage = 'Please contact support.';

export const passwordReusedErrorCode = 'PASSWORD_REUSED';
